import { useEffect, useState } from "react"
import './Products.scss'
import axios from "axios"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { useSnackbar } from "notistack"
import { Baseurl } from "../../src/constants/env"
import Banner from "./banner/Banner"
import Tempfooter from "./Tempfooter"
import Countdown from "./Countdown"
import Slider from "react-slick"
import { useLocation } from "react-router-dom"
import Seo from "./common/seocomp/Seo"
const Products = () => {
  const [data, setData] = useState([]);
  const [categ, setCateg] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  let [loading, setLoading] = useState(false);
  let [error, seterror] = useState(false);
  const { userid } = useSelector((state) => state.auth);
  const [searchCategory, setSearchCat] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItemSet, setSelectedItemSet] = useState(new Set());
  const [dealdata, setDealdata] = useState([]);
    const [branddata, setBranddata] = useState([]) 
    const [contry,setContry] = useState([])
const location = useLocation()

const [endDate, setEnddate] = useState() 
 
const Navigate = useNavigate()
  useEffect(() => {
    if(location.pathname === '/'){
         getprodutsdata();
    }

  }, []);

  const handleSelectUser = (prod) => {
    setSelectedItems([...selectedItems, prod ])
    setSuggestions([])
    if( searchTerm == ""){
      return
    }
    setSearchTerm(prod.name)
   
  };


  const handleRemoveUser = (prod) => {
    const updatedItems = selectedItems.filter( (selectedUser) => selectedUser._id !== prod._id)
    setSelectedItems(updatedItems);
    const updatedUsers = new Set(selectedItemSet)
    updatedUsers.delete(prod._id)
    setSelectedItemSet(updatedUsers)
  };

  const detailPage = (id,names) => {
    let name = names?.replace(/[\s/]/g, "-");
    Navigate(`/product/${name}/${id}`)
  }

  const detaildealPage = (id,category,string,item) => {
    if(string === 'deal'){
      item.productId.ourprice =  item.productId.ourprice - item.discount  
      let data =  item.productId
      let name = item?.productId?.name?.replace(/[\s/]/g, "-");
      return Navigate(`/product/${name}/${id}`,{state:data})
    }
  }


  async function getprodutsdata() {
    setLoading(true);

    let cat = await axios(`${Baseurl}/category`)
    setCateg(cat.data.data)

    await axios(`${Baseurl}/products?limit=8`, {
      withCredentials: true,
    })
      .then((resp) => {
        setData(resp.data.data);
        seterror(false);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e.message);
        setLoading(false);

        enqueueSnackbar("Something Failed", { variant: "error" });
        seterror(true);
      });

      let res = await axios.get(`${Baseurl}/deal`)
      
      setDealdata(res?.data[0])
      setEnddate(res?.data[0]?.endDate)
      let brand = await axios.get(`${Baseurl}/brand`) 
      setBranddata(brand?.data?.data)

      let country = await axios.get(`${Baseurl}/country`)
      setContry(country?.data) 

  }


   
        const settings2 = {
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 5 || 0, // Show all images in one row 
          slidesToScroll: 1,
          arrows: true, // Optional: Add navigation arrows
          autoplay: true, // Enable auto-sliding
          autoplaySpeed: 3000,
          responsive: [ // Optional: Adjust responsiveness if needed
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 5 || 0,
                slidesToScroll: 1,
                infinite: true,
                dots: false,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 5 || 0,
                slidesToScroll: 1,
                initialSlide: 1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3 || 0,
                slidesToScroll: 1,
              },
            },
          ],
        };

        var settings1 = {
          dots: false,
          infinite: true ,
          speed: 500,
          slidesToShow: contry?.length || 0, // Show all images in one row 
          slidesToScroll: 1,
          arrows: true, // Optional: Add navigation arrows
          autoplay: true, // Enable auto-sliding
          autoplaySpeed: 3000,
          responsive: [ // Optional: Adjust responsiveness if needed
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: contry?.length || 0,
                slidesToScroll: 1,
                infinite: true,
                dots: false,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: contry?.length || 0,
                slidesToScroll: 1,
                initialSlide: 1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2 || 0,
                slidesToScroll: 1,
              },
            },
          ],
        };

        var settings3 = {
          dots: false,
          infinite: true ,
          speed: 500,
          slidesToShow: 3 || 0, // Show all images in one row 
          slidesToScroll: 1,
          arrows: true, // Optional: Add navigation arrows
          autoplay: true, // Enable auto-sliding
          autoplaySpeed: 3000,
          responsive: [ // Optional: Adjust responsiveness if needed
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2 || 0,
                slidesToScroll: 1,
                infinite: true,
                dots: false,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2 || 0,
                slidesToScroll: 1,
                initialSlide: 1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2 || 0,
                slidesToScroll: 1,
              },
            },
          ],
        };

 function calculatePercentage(prod, discont){
  let percentageOfOriginal = (discont / prod) * 100;
  return parseFloat(percentageOfOriginal.toFixed(1)) + "%";
 }  
 
 const movetoDeal = () => {
  Navigate('/deals')
 }

  const pageTitle = "Commercial Kitchen Equipment Store | Imox Kitchen";
  const pageDescription = "Imox Kitchen Equipment LLC in Dubai offers top commercial kitchen design, hygiene products, and refurbished equipment with 15+ years of trusted service.";
  const pageCanonicalUrl = "https://imoxkitchen.com/"; 
  const keyWords = "Imox Kitchen Equipment, commercial kitchen equipment Dubai, kitchen equipment UAE, refurbished kitchen equipment, commercial kitchen design, kitchen equipment servicing, catering equipment Dubai, bakery equipment UAE, hygiene products for kitchens, kitchen equipment repairs, UAE kitchen suppliers, kitchen equipment trading, Dubai kitchen installation, kitchen supply UAE, commercial catering equipmentkitchen equipment store, kitchen equipment supplier, restaurant equipment supplier in uae, online kitchen equipment shop" 
  const ogDescription = "Imox Kitchen Equipment LLC in Dubai offers top commercial kitchen catering and bakery machineries , branded products, and refurbished equipments with 15+ years of trusted service." 
  const ogImage = "https://imoxkitchen.com/images/logo.png"
  // const pageOgImage = "https://www.example.com/images/og-home.jpg"; 
  // const pageTwitterImage = "https://www.example.com/images/twitter-home.jpg";  
  return (
   <>

<Seo title={pageTitle}
        description={pageDescription}
        keyWords={keyWords}
        canonicalUrl={pageCanonicalUrl}
        ogDescription={ogDescription}
        ogImage={ogImage}
         />

<main className="main text-primary">
<Banner />
<section class="section-deals">
<div class="container">
{endDate > new Date().toISOString() ? 
  <div class="deal-block" >
    <div class="row">
      <div class="col-md-3">

        <div class="deal-block-left" onClick={movetoDeal} style={{ cursor: 'pointer' }}>

<h5>Deals and offers</h5>
<p>Hygiene equipments</p>

<Countdown endDate={endDate} />
        </div>
      </div>
      <div class="col-md-9">
<div class="row mt-4 mb-4">

{endDate > new Date().toISOString() ? (
  <Slider {...settings3}>
    {dealdata?.products?.map((item, index) => 
     (

  <div key={index}>
        <button onClick={() => detaildealPage(item?.productId?._id, item?.productId?.category?.name, 'deal', item)}>
          <div className="product-box ms-3">
            <div className="project-image">
            <span className="offer-label text-white">{calculatePercentage(item?.productId.ourprice, item?.discount )}</span>
              <img
                src={`${Baseurl}/view/imageupload/${item?.productId?.img}?t=${new Date().getTime()}` }
                className="img-fluid"
                loading="lazy" alt={`${item?.productId?.name} in uae`} 
              />
            </div>
            <div className="product-details">
              <h4>{item?.productId?.name || "Product Name"}</h4>
              <div>
                <span className="price"><img className="d-inline" width={15} src="/images/uae-dirham-icon.svg" /> {item?.productId?.ourprice - item?.discount}</span>
                <span className="crossed-price"> <img className="d-inline-block ms-1" width={12} src="/images/uae-dirham-icon.svg" /> {item?.productId?.mrpprice}</span>
              </div>
              <div className="ratings mb-2 mt-1">
                {[...Array(5)].map((_, i) => (
                  <i
                    key={i}
                    className={`bi bi-star-fill ${
                      i < Math.round(item?.productId?.averageRating || 0)
                        ? 'text-warning'
                        : 'bi-star text-secondary'
                    } me-2`}
                    style={{ fontSize: '1rem' }}
                  ></i>
                ))}
                {`${Number.isInteger(item?.productId?.averageRating) ? item?.productId?.averageRating + '.0' : item?.productId?.averageRating}`}
              </div>
            </div>
          </div>
        </button>
      </div>
  

    ))}
  </Slider>
) : null}
</div>

      </div>
      </div>
      </div> : <></> }

    </div>


  </section>

  <section class="section-recomend">

<div class="container">
<div class="row">

<div class="col-md-12">
  <h2>Recommended items</h2>
</div>

</div>

<div class="row">
 
 

  {data?.map((item,index) => {
    return (
      <div class="col-md-3 col-6" key={index}>
      <button className="" onClick={()=>detailPage(item._id,item.name)}>
      <div class="product-box" >

<div class="project-image">

  <img src={`${Baseurl}/view/imageupload/${item?.img}?t=${new Date().getTime()}`} class="img-fluid" loading="lazy" alt={`${item?.name} in uae`}  />

</div>


                  <div className={` w-100 h-100 text-center text-white ${item?.quantity <= 0 ? 'bg-danger' : 'bg-dark'}`}>
    {item?.quantity <= 0 ? (
        'SOLD OUT'
    ) : (
        item.type === '67d398c821d91ac853505b54' ? 'USED' :
        item.type === '67d3992621d91ac853505b55' ? 'REFURBISHED' :
        item.type === '67d3997721d91ac853505b56' ? 'BRAND NEW' : ''
    )}
</div>


<div class="product-details">
  <h4>
    {item?.name}
  </h4>
<div>              <span class="price">  <img width={13} src="/images/uae-dirham-icon.svg" /> {item?.ourprice}</span> <span class="crossed-price"><img width={11} src="/images/uae-dirham-icon.svg" /> {item?.mrpprice}</span>
</div>
<div class="ratings mb-2 mt-1">
{[...Array(5)].map((_, i) => (
  <i
    key={i}
    className={`bi bi-star-fill ${
      i < Math.round(item?.averageRating || 0)
        ? 'text-warning' 
        : 'bi-star text-secondary' 
    } me-2`} 
    style={{ fontSize: '1rem' }} 
  ></i>
))} 
{`${Number.isInteger(item?.averageRating) ? item?.averageRating + '.0' : item?.averageRating}`}
</div>
</div>
</div> </button> </div>
    )
  })}

</div>

</div>


  </section>


  <section class="section-delivery-countries">

<div class="container">

  <div class="row">
    <div class="col-md-12">

      <h2><span>Delivery Available Coutries</span> </h2>


    </div>


    <div className="col-md-12">
      <div className="swiper swiper-partners">
        <div className="swiper-wrapper">
          <div className="swiper-slide "> 
            <Slider {...settings1}>
              {contry?.map((item, index) => (
                <div className="d-flex align-items-center" key={index}>
                 <img
                   style={{  width: '40px' }} 
                    class="me-2 "
                    src={`${Baseurl}/view/imageupload/${item?.img}?t=${new Date().getTime()}`}
                    alt="failed"
                  /> <span>{item?.name}</span> 
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
      </div>


    </div>



  </section>

  <section class="section-delivery-countries">

<div class="container">

  <div class="row">
    <div class="col-md-12">

      <h2><span>Brands</span> </h2>


    </div>

    <div className="col-md-12">
      <div className="swiper swiper-partners">
        <div className="swiper-wrapper">
          <div className="swiper-slide"> 

          <div className="swiper-slide "> 
            <Slider {...settings2}>
              {branddata?.map((item, index) => (
                <div className="d-flex justify-content-between " key={index}>
                 <img
                   style={{  width: '80px' }} 
                    className=""
                    src={`${Baseurl}/view/imageupload/${item?.img}?t=${new Date().getTime()}`}
                    alt="failed"
                  /> 
                </div>
              ))}
            </Slider>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


  </section>

</main>




<Tempfooter />










    <section className="container-fluid" >
    <div className="row">
 
    </div>

    <hr />
        {/* <div className='row pb-2'>
          <div className='col-sm-12'>
            <div className='fs-2'>
            <button onClick={testing}>hhh</button>
              <p>Related Poducts</p>
            </div>
            <div className='d-flex gap-3 flex-wrap  justify-content-center  align-items-center pb-3'>
  {
    data?.map((item,index) => {
      return (
     <div key={item._id}>
      <div className="card" style={{width: '15rem',height:'19rem'}}>
  <button className="" onClick={()=>detailPage(item._id,item.category?.name)}>
    <div><img style={{width:'138px', height:'150px',borderRadius:'5px'}} src={`${Baseurl}/view/imageupload/${item.img}`} /></div>
    { item.type === 'old' ?<div className='border text-center p-1 bg-info'>OLD</div> :''}
    { item.type === 'refurbmished' ?<div className='border text-center p-1 bg-danger'>REFURBMISHED</div> :''}
    { item.type === 'brandnew' ?<div className='border text-center p-1 bg-success'>BRAND NEW</div> :''}
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center p-1 text-nowrap bg-light w-100'>{item.name}</div> 
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center pb-1 text-nowrap bg-light w-100'>{item?.brand?.name}</div> 
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center p-1 text-nowrap bg-light w-100'>{item.name}</div> 
    <div style={{overflow:'hidden',textOverflow:'ellipsis'}} className='border text-center  text-nowrap bg-light w-100 d-flex justify-content-center gap-1'>
    <span><del>{item.mrprice}</del></span> <span>{item.ourprice}</span></div> 

  </button>
</div>
        </div>
      )
    })
  }
</div>
          </div>
        </div> */}

    </section>
   </>
  )
};

export default Products;
